import React, { useState, useEffect } from 'react';

import {
    Form,
    Tabs,
  Badge,
  TabBar,
  Button,ImageViewer,SideBar,List,Image,Grid,Popup,Stepper,Modal, Toast,NavBar,Divider,JumboTabs
} from 'antd-mobile-v5';
import { HandPayCircleOutline,StarOutline,StarFill } from 'antd-mobile-icons'
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import 'antd/dist/antd.css';
import '../../assets/font/font.css'
import '../Home/index.css'

import {
    GetDeathList, GetWXJSSDK, GetPlanetInfo, GetDataDictionarysByCode,SaveShoppingOrder,GetPlanetProductPayRecords,
    GetNNProductsByTypeId, GetNNProductInfoById, GetJsApiPay, PostNNShoppingOrders,InsertPlanetFamilyGroup
} from '../../service/service';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { environment } from '../../service/baseUrl';


class TextCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0
        };
        this.timer = null;
    }

    componentDidMount() {
        this.startCarousel();
    }

    componentWillUnmount() {
        this.stopCarousel();
    }

    startCarousel = () => {
        const { interval = 3000 } = this.props;
        this.timer = setInterval(() => {
            this.setState(prevState => ({
                currentIndex: (prevState.currentIndex + 1) % this.props.messages.length
            }));
        }, interval);
    };

    stopCarousel = () => {
        if (this.timer) {
            clearInterval(this.timer);
        }
    };

    getVisibleMessages = () => {
        const { currentIndex } = this.state;
        const { messages = [], visibleCount = 3 } = this.props;
        const result = [];
        
        // 获取当前组消息（从当前索引开始取3条）
        for (let i = 0; i < visibleCount && i <= this.props.messages.length; i++) {
            const index = (currentIndex + i) % messages.length;
            result.push(messages[index]);
        }
        
        return result;
    };

    render() {
        const visibleMessages = this.getVisibleMessages();

        return (
            <div className="text-carousel-container" onClick={() => {
                this.props.jumpGiftList();
            }}>
                <div className="text-carousel-stack">
                    {visibleMessages.map((message, index) => {
                        var str = "";
                        // if (index == 2) {
                        //     str = "enter-active";
                        // }
                        if (index == 0) {
                            str = "exit-active";
                        }

                        return (
                            <div
                                key={`${message}-${index}`}
                                className={"text-carousel-item " + str}
                            >
                                {message}
                            </div>
                        );
                    })}

                </div>
            </div>
        );
    }
}


const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            userInfo: {},
            planetInfo: {},
            dataMsg: "数据加载中...",

            visibleQF: false,
            visibleQFOver: false,
            visibleXH: false,
            visibleImg: false,
            visibleCP: false,

            visibleShare: false,
            IsAdmin: false,
            isShow: false,

            titleTab: 0,
            typeTab: 0,

            tabTypes: [],
            products: [],
            productInfo: {},
            productActiveKey: 0,
            productInfoPrice: 0,

            bjstyles: [],
            messages: [],
            errorInfo: "加载中...",
        };
    }

    componentDidMount() {
        var that = this;

        const script = document.createElement('script');
        script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
        script.async = true;
        document.body.appendChild(script);

        const { location } = this.props;
        // const { id } = location.state || {}; // 获取 URL 参数
        var id = location.state == null ? null : location.state.id;
        
        const searchParams = new URLSearchParams(window.location.search);
        const planetId = searchParams.get('planetId');
        if (planetId != null && planetId != "") {
            id = planetId;
            if (id) {
                that.setState({
                    id: id,
                })
            }

            that.insertPlanetFamilyGroup();
        }

        if (id) {
            that.setState({
                id: id,
            })
            
            var user = localStorage.getItem("user");

            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var isAdmin = false;
                    if (res.result.openId == JSON.parse(user).openId) {
                        isAdmin = true;
                    } else {
                        var items = res.result.planetFamilyGroupDtos.filter(x => x.openId == JSON.parse(user).openId);
                        if (items.length > 0) {
                            isAdmin = items[0].isAdmin;
                        }
                    }
                    
                    that.setState({
                        IsAdmin: isAdmin,
                        planetInfo: res.result,
                        id: id,
                    }, () => {
                        that.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-15.png)", "35px 35px", "xin");
                        that.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-16.png)", "35px 35px", "edit");
                        that.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-17.png)", "35px 35px", "mu");
                        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-19.png)", "25px 25px", "users");
                    })
                } else {
                    this.setState({
                        errorInfo: "内部异常"
                    })
                }
            })

            GetPlanetProductPayRecords(id).then(res => {
                if (res.success) {
                    var list = [];
                    const currentMonth = new Date().getMonth() + 1; // 月份从0开始，所以+1
                    var quarter = 0;
                    switch (true) {
                        case (currentMonth >= 1 && currentMonth <= 3):
                            quarter = 509;
                            break;
                        case (currentMonth >= 4 && currentMonth <= 6):
                            quarter = 510;
                            break;
                        case (currentMonth >= 7 && currentMonth <= 9):
                            quarter = 511;
                            break;
                        case (currentMonth >= 10 && currentMonth <= 12):
                            quarter = 512;
                            break;
                        default:
                            quarter = 0;
                    }

                    res.result.map(item => {
                        var name = item.productImgUrl == null ? null : item.productImgUrl.split('/').pop()
                        var items = list.filter(x => x.name == name);

                        if (!(items.length > 0) && item.productTypeId != 497
                            && item.productTypeId != 498 && item.productTypeId != 499
                            && (item.sasonId == quarter || item.sasonId == 514)) {

                            switch (item.productTypeId) {
                                case 488:
                                    list.push({
                                        ZIndex: 99,
                                        name: name
                                    })
                                    break;
                                case 489:
                                    list.push({
                                        ZIndex: 98,
                                        name: name
                                    })
                                    break;
                                case 487:
                                    list.push({
                                        ZIndex: 97,
                                        name: name
                                    })
                                    break;
                                case 490:
                                    list.push({
                                        ZIndex: 96,
                                        name: name
                                    })
                                    break;
                                case 491:
                                    list.push({
                                        ZIndex: 95,
                                        name: name
                                    })
                                    break;
                                default:
                                    break;
                            }
                        }

                    })

                    that.setState({
                        bjstyles: list,
                    })
                }
            })

            if (user == null || user == undefined) {
    
            } else {
                this.setState({
                    userInfo: JSON.parse(user)
                })
            
                var data = {
                    PlanetId: id,
                    MaxResultCount: 9999,
                    PayState: 2
                    // OpenId: JSON.parse(user).openId
                };
                PostNNShoppingOrders(data).then(res => {
                    if (res.success) {
                        var messages = [];

                        res.result.items.map(item => {
                            var str = "点亮了";
                            switch (item.productTypeId) {
                                case 487:
                                    str = "种植了";
                                    break;
                                case 489:
                                    str = "领养了";
                                    break;
                                case 490:
                                    str = "建设了";
                                    break;
                                case 499:
                                    str = "献祭了";
                                    break;
                                case 516:
                                    str = "";
                                    break;
                                case 497:
                                case 498:
                                    str = "点亮了";
                                    break;
                                default:
                                    str = "装饰了";
                                    break;
                            }

                            var str1 = item.creatorUserName + " " + str + "：" + item.productName;
                            var items1 = messages.filter(x => x == str1);
                            if (!(items1.length > 0)) {
                                messages.push(item.creatorUserName + " " + str + "：" + item.productName)
                            }
                        })
                        that.setState({
                            // bjstyles: list,
                            messages
                        })
                    }
                })
            }

        }

        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-18.png)", "40px 45px", "fu");

        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-10.png)", "35px 38px", "liuyan");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-11.png)", "35px 38px", "yuyin");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-12.png)", "35px 38px", "img");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-13.png)", "35px 38px", "video");

        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-14.png)", "35px 35px", "share");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-19.png)", "25px 25px", "users");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-15.png)", "35px 35px", "xin");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-16.png)", "35px 35px", "edit");
        this.onChangeBackground("url(https://api.weibinyi.com/images/niannian/3/4-17.png)", "35px 35px", "mu");


        var jsApiList = [
            'checkJsApi',
            'openLocation',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'updateAppMessageShareData',
            'updateTimelineShareData'
        ];

        setTimeout(() => {

            var url = window.location.href.split('#')[0];
            url = encodeURIComponent(url);

            GetWXJSSDK(url).then(res => {
                var json = JSON.parse(res.result);
                json.jsApiList = jsApiList;
                json.appId = json.AppId;
                json.debug = true;
                json.nonceStr = json.noncestr;
                // window.wx.config(json);
                var configStr = {
                    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                    appId: json.appId, // 必填，公众号的唯一标识
                    timestamp: parseInt(json.timestamp), // 必填，生成签名的时间戳
                    nonceStr: json.nonceStr, // 必填，生成签名的随机串
                    signature: json.signature,// 必填，签名
                    jsApiList: jsApiList, // 必填，需要使用的 JS 接口列表
                };
                window.wx.config(configStr);

                that.initWxShare();
            })
        }, 1000);


        GetDataDictionarysByCode("CPZBLB").then(res => {
            if (res.success) {
                var arry = [];
                var typeTab = 0;
                res.result.map((item, index) => {
                    if (item.displayName != "河灯" && item.displayName != "孔明灯" && item.displayName != "献祭") {
                        if (index == 0) {
                            typeTab = item.id;
                        }
                        arry.push({ text: item.displayName, id: item.id })
                    }
                })
                that.setState({
                    tabTypes: arry,
                    typeTab: typeTab,
                })
                that.loadProduct(typeTab);
            }
        })

    }

    initWxShare() {
        var that = this;

        if (that.state.planetInfo.name != null) {

            var imgUrl = that.state.planetInfo.headImg == null ?
                "https://api.weibinyi.com/images/niannian/thtx.jpg" :
                environment.apiEndpoint + "/NNFiles/Img/" + that.state.planetInfo.headImg;

            window.wx.ready(function () {

                //“分享给朋友”及“分享到QQ”
                window.wx.updateAppMessageShareData({
                    title: that.state.planetInfo.name + "的主页", // 分享标题
                    desc: that.state.planetInfo.name + "的主页", // 分享描述
                    link: window.location.href, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // Toast.show({
                        //     content: "分享成功"
                        // });
                    },
                    cancel: function () {
                        Toast.show({
                            content: "取消分享"
                        });
                    }
                });
                //“分享到朋友圈”及“分享到QQ空间”
                window.wx.updateTimelineShareData({
                    title: that.state.planetInfo.name + "的主页", // 分享标题
                    desc: that.state.planetInfo.name + "的主页", // 分享描述
                    link: window.location.href, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // Toast.show({
                        //     content: "分享成功"
                        // });
                    },
                    cancel: function () {
                        Toast.show({
                            content: "取消分享"
                        });
                    }
                });
                //分享到朋友圈
                window.wx.onMenuShareTimeline({
                    title: that.state.planetInfo.name + "的主页", // 分享标题
                    desc: that.state.planetInfo.name + "的主页", // 分享描述
                    link: window.location.href, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // Toast.show({
                        //     content: "分享成功"
                        // });
                    },
                    cancel: function () {
                        Toast.show({
                            content: "取消分享"
                        });
                    }
                });
                //分享给朋友
                window.wx.onMenuShareAppMessage({
                    title: that.state.planetInfo.name + "的主页", // 分享标题
                    desc: that.state.planetInfo.name + "的主页", // 分享描述
                    link: window.location.href, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // Toast.show({
                        //     content: "分享成功"
                        // });
                    },
                    cancel: function () {
                        Toast.show({
                            content: "取消分享"
                        });
                    }
                });


            })
        } else {
            setTimeout(() => {
                that.initWxShare();
            }, 1000);
        }
    }

    insertPlanetFamilyGroup = (isCancel = false) => {
        var that = this;
        const searchParams = new URLSearchParams(window.location.search);
        const planetId = searchParams.get('planetId');

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            that.insertPlanetFamilyGroup();
            return;
        }
        var openid = localStorage.getItem("openid")
        if (openid == null || openid == "" || openid == undefined) {
            that.insertPlanetFamilyGroup();
        } else {
            InsertPlanetFamilyGroup({
                PlanetId: planetId,
                OpenId: openid,
                IsCancel: isCancel,
            }).then(res => {
                if (res.success) {

                    if (isCancel) {
                        GetPlanetInfo(that.state.id).then(res => {
                            if (res.success) {
                                var isAdmin = false;
                                if (res.result.openId == JSON.parse(user).openId) {
                                    isAdmin = true;
                                } else {
                                    var items = res.result.planetFamilyGroupDtos
                                        .filter(x => x.openId == JSON.parse(user).openId);
                                    if (items.length > 0) {
                                        isAdmin = items[0].isAdmin;
                                        Toast.show({ icon: 'success', content: '关注成功！' });
                                    } else {
                                        Toast.show({ icon: 'success', content: '已取消关注！' });
                                    }
                                }

                                that.setState({
                                    IsAdmin: isAdmin,
                                    planetInfo: res.result,
                                })
                            }
                        })
                    }

                }
            })

            // var planetIdStr = localStorage.getItem("planetId");
            // if (planetIdStr == null || planetIdStr == undefined || planetIdStr == "" || planetIdStr != planetId) 
            // {
            //     InsertPlanetFamilyGroup({
            //         PlanetId: planetId,
            //         OpenId: openid,
            //         IsCancel: isCancel,
            //     }).then(res => {
            //         localStorage.setItem("planetId", planetId);
            //         if (res.success) {
    
            //         }
            //     })
            // }
        }
    }

    onChangeBackground(url, size, name) {
        var index = document.getElementById(name);
        if (index != null) {
            index.style.backgroundImage = url;
            index.style.backgroundSize = size;
            index.style.zIndex = "100";
        }

    }


    showImg() {
        Modal.show({
            content: <Image fit='cover'
                src="https://api.weibinyi.com/images/niannian/home_hua.png" />,
            closeOnMaskClick: true,
            actions: [],
        })

    }

    changeBjStyles(list) {
        var productInfo = this.state.productInfo;
        if (!productInfo.imgUrl) {
            return list;
        }
        var name = productInfo.imgUrl.split('/').pop();
        switch (productInfo.typeId) {
            case 488:
                list.push({
                    ZIndex: 99,
                    name: name
                })
                break;
            case 489:
                list.push({
                    ZIndex: 98,
                    name: name
                })
                break;
            case 487:
                list.push({
                    ZIndex: 97,
                    name: name
                })
                break;
            case 490:
                list.push({
                    ZIndex: 96,
                    name: name
                })
                break;
            case 491:
                list.push({
                    ZIndex: 95,
                    name: name
                })
                break;
            default:
                break;
        }

        return list;
    }

    payProduct() {
        var data = {
            ProductId: this.state.productInfo.id,
            ProductPriceId: this.state.productActiveKey,
            PayType: 1,
            PlanetId: this.state.id,
        };
        var that = this;

        if (!this.state.productInfoPrice) {
            SaveShoppingOrder(data).then(res => {
                var list = that.state.bjstyles;
                list = that.changeBjStyles(list);

                if (res.success) {
                    if (res.result) {
                        var isShow = true;
                        that.setState({
                            visibleQF: false,
                            visibleQFOver: false,
                            visibleXH: false,
                            visibleImg: false,
                            visibleCP: false,
                            visibleShare: false,
                            isShow: isShow,
                            bjstyles: list,
                        })
                        // Toast.show({
                        //   icon: 'success',
                        //   content: '购买成功！',
                        // })

                        setTimeout(() => {
                            that.setState({
                                isShow: false,
                            })
                        }, 3500);

                    } else {
                        Toast.show("内部错误！");
                    }
                } else {
                    Toast.show("内部错误！");
                }
            })
        } else {
            GetJsApiPay(data).then(res => {
                if (res.success) {
                    // Toast.info(res.result, 2);
    
                    that.jsApiCall(res.result);
                } else {
                    Toast.show("内部错误！");
                }
            })
        }

    }

    jsApiCall(wxJsApiParam) {
        var that = this;

        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            JSON.parse(wxJsApiParam),//josn串
            function (res) {
                switch (res.err_msg) {
                    case 'get_brand_wcpay_request:cancel':

                        Toast.show("用户取消支付!");
                        break;
                    case 'get_brand_wcpay_request:fail':

                        Toast.show("支付失败！（" + res.err_desc + "）");
                        break;
                    case 'get_brand_wcpay_request:ok':
                        var list = that.state.bjstyles;
                        list = that.changeBjStyles(list);

                        var isShow = false;
                        if (that.state.titleTab == 1) {
                            isShow = true;
                        }
                        that.setState({
                            visibleQF: false,
                            visibleQFOver: false,
                            visibleXH: false,
                            visibleImg: false,
                            visibleCP: false,
                            visibleShare: false,
                            isShow: isShow,
                            bjstyles: list,
                        })
                        Toast.show({
                          icon: 'success',
                          content: '购买成功！',
                        })

                        setTimeout(() => {
                            that.setState({
                                isShow: false,
                            })
                        }, 3500);

                        break;
                    default:
                        Toast.info(JSON.stringify(res), 1);
                        break;
                }
            }
        );
    }



    loadProduct = (typeId) => {
        var that = this;
        GetNNProductsByTypeId(typeId).then(res => {
            if (res.success) {
                var list = [];
                const currentMonth = new Date().getMonth() + 1; // 月份从0开始，所以+1
                var quarter = 0;
                switch (true) {
                    case (currentMonth >= 1 && currentMonth <= 3):
                        quarter = 509;
                        break;
                    case (currentMonth >= 4 && currentMonth <= 6):
                        quarter = 510;
                        break;
                    case (currentMonth >= 7 && currentMonth <= 9):
                        quarter = 511;
                        break;
                    case (currentMonth >= 10 && currentMonth <= 12):
                        quarter = 512;
                        break;
                    default:
                        quarter = 0;
                }
                
                res.result.map(item => {
                    if (item.seasonId == quarter || item.seasonId == 514) {
                        list.push(item);
                    }
                })

                that.setState({
                    products: list
                })
            }
        })
    }

    getProductInfo = (id) => {
        var that = this;
        GetNNProductInfoById(id).then(res => {
            if (res.success) {
                var name = res.result.coverPhoto.split('/').pop();
                res.result.coverPhoto = environment.apiEndpoint + "/NNFiles/Img/" + name;
                if (res.result.typeId == 499) {
                    that.setState({
                        productInfo: res.result,
                        visibleCP: true,
                        productInfoPrice: res.result.price,
                        productActiveKey: null,
                        // productActiveKey: (res.result.productPriceDtos == null || res.result.productPriceDtos.length == 0)
                        //     ? 0 : (res.result.productPriceDtos[0].id + ""),
                    })
                } else {
                    that.setState({
                        productInfo: res.result,
                        visibleCP: true,
                        productInfoPrice: (res.result.productPriceDtos == null || res.result.productPriceDtos.length == 0)
                            ? 0 : res.result.productPriceDtos[0].price,
                        productActiveKey: (res.result.productPriceDtos == null || res.result.productPriceDtos.length == 0)
                            ? 0 : (res.result.productPriceDtos[0].id + ""),
                    })
                }
            }
        })
    }

    openMapWithNavigation = (latitude, longitude, name, address) => {
        // 1. 优先尝试通用geo协议（唤起手机自带地图）
        const geoUrl = `geo:${latitude},${longitude}?q=${encodeURIComponent(name)}&address=${encodeURIComponent(address)}`;
        window.location.href = geoUrl;

        // 2. 如果geo协议失败（500ms后未跳转），降级处理
        setTimeout(() => {
            // 判断是否是iOS设备
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

            if (isIOS) {
                // iOS专属方案：跳转苹果地图
                window.location.href = `http://maps.apple.com/?ll=${latitude},${longitude}&q=${encodeURIComponent(name)}&address=${encodeURIComponent(address)}`;
            } else {
                // 其他情况：使用百度地图H5（你的原始方案）
                window.open(
                    `https://api.map.baidu.com/marker?location=${latitude},${longitude}` +
                    `&title=${encodeURIComponent(name)}` +
                    `&content=${encodeURIComponent(address)}` +
                    `&output=html`
                );
            }
        }, 500);
    }

    render() {

        return (
            <div id="home" className="home" style={{ height: "100%", height: "100%" }}>
                <NavBar back='首页' onBack={() => {
                    this.props.navigate('/index', { replace: true }); // 传递状态
                }} style={{
                    position: "absolute", zIndex: "99999"
                }}>
                </NavBar>

                {
                    this.state.bjstyles.map(item => {
                        return (<div style={{
                            backgroundImage: "url('https://api.weibinyi.com/NNFiles/Img/" + item.name + "')"
                            , backgroundRepeat: "no-repeat", height: "100%", width: "100%", backgroundSize: "100% 100%"
                            , position: "absolute", zIndex: item.ZIndex
                        }}></div>)
                    })
                }
                
                

                
                {/* <div id="yuyin" style={{
                    width: "35px", height: "38px", position: "absolute", marginTop: "14%"
                    , backgroundRepeat: "no-repeat", backgroundPosition: "left", marginLeft: "2%"
                }} onClick={()=>{
                    this.props.navigate('/medias', { replace: true, state: { id: this.state.id } }); // 传递状态
                }}>
                </div> */}
                <div id="liuyan" style={{
                    width: "35px", height: "38px", position: "absolute", marginTop: "15%"
                    , backgroundRepeat: "no-repeat", backgroundPosition: "left", marginLeft: "2%"
                }} onClick={()=>{
                    this.props.navigate('/msg', { replace: true, state: { id: this.state.id } }); // 传递状态
                }}>
                </div>
                <div id="img" style={{
                    width: "35px", height: "38px", position: "absolute", marginTop: "29%"
                    , backgroundRepeat: "no-repeat", backgroundPosition: "left", marginLeft: "2%"
                }} onClick={()=>{
                    this.props.navigate('/albumClass', { replace: true, state: { id: this.state.id } }); // 传递状态
                }}>
                </div>
                <div id="video" style={{
                    width: "35px", height: "38px", position: "absolute", marginTop: "43%"
                    , backgroundRepeat: "no-repeat", backgroundPosition: "left", marginLeft: "2%"
                }} onClick={()=>{
                    this.props.navigate('/videos', { replace: true, state: { id: this.state.id } }); // 传递状态
                }}>
                </div>



                <div id="share" style={{
                    width: "30px", height: "30px", position: "absolute", marginTop: "13%", right: "0%"
                    , backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "2%"
                }} onClick={()=>{
                    var openid = localStorage.getItem("openid")
                    if (openid == "oJEYQwYYswEZAQCM7RCsGMyGNxM8" || openid == "oJEYQwTmuK1v8AoaotS6kDkXXVZE"
                        || openid == "oJEYQwUBpmZl3MzTiYADeoUetsvw") {
                        this.props.navigate('/aiChat', { replace: true, state: { id: this.state.id } }); // 传递状态
                        return;
                    }

                    this.setState({
                        visibleShare: true
                    })
                }}>
                </div>

                {
                    this.state.IsAdmin ?
                        <>
                            {/* <div id="users" style={{
                                width: "30px", height: "30px", position: "absolute", marginTop: "23%", right: "0%"
                                , backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "3.5%"
                            }} onClick={() => {
                                this.props.navigate('/familyRegistry', {
                                    replace: true,
                                    state: { id: this.state.id, dataScoureId: this.state.planetInfo.dataScoureId }
                                }); // 传递状态
                            }}>
                            </div> */}
                            <div id="edit" style={{
                                width: "30px", height: "30px", position: "absolute", marginTop: "23%", right: "0%"
                                , backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "2%"
                            }} onClick={() => {
                                this.props.navigate('/formEdit', { replace: true, state: { id: this.state.id } }); // 传递状态
                            }}>
                            </div>
                        </> :
                        <div id="xin" style={{
                            width: "30px", height: "30px", position: "absolute", marginTop: "23%", right: "0%"
                            , backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "2%"
                        }} onClick={() => {
                            var that = this;

                            this.insertPlanetFamilyGroup(true);
                        }}>
                        </div>
                }

                {
                    this.state.planetInfo.isBuried ?
                        <div id="mu" style={{
                            width: "30px", height: "30px", position: "absolute", marginTop: this.state.IsAdmin ? "33%" : "23%"
                            , right: "0%", backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "2%"
                        }} onClick={() => {

                            var that = this;
                            var planetInfo = this.state.planetInfo;
                            window.wx.ready(() => {

                                window.wx.checkJsApi({
                                    jsApiList: ['openLocation'],
                                    success: function (res) {
                                        if (res.checkResult.openLocation === false) {
                                            window.open(`https://api.map.baidu.com/marker?location=${parseFloat(planetInfo.hotelDto.yAxis)},${parseFloat(planetInfo.hotelDto.xAxis)}&title=${planetInfo.hotelDto.name}&content=${planetInfo.hotelDto.address}&output=html`);
                                        } else {
                                            window.wx.openLocation({
                                                // latitude: parseFloat(planetInfo.hotelDto.xAxis),
                                                // longitude: parseFloat(planetInfo.hotelDto.yAxis),

                                                latitude: parseFloat(planetInfo.hotelDto.yAxis),
                                                longitude: parseFloat(planetInfo.hotelDto.xAxis),
                                                name: planetInfo.hotelDto.name,
                                                address: planetInfo.hotelDto.address,
                                                scale: 15,
                                                fail: (err) => {
                                                    // window.open(`https://api.map.baidu.com/marker?location=${parseFloat(planetInfo.hotelDto.yAxis)},${parseFloat(planetInfo.hotelDto.xAxis)}&title=${planetInfo.hotelDto.name}&content=${planetInfo.hotelDto.address}&output=html`);
                                                    
                                                    that.openMapWithNavigation(
                                                        parseFloat(planetInfo.hotelDto.yAxis),
                                                        parseFloat(planetInfo.hotelDto.xAxis),
                                                        planetInfo.hotelDto.name,
                                                        planetInfo.hotelDto.address
                                                    );
                                                }
                                            });
                                        }
                                    }
                                });

                            });
                        }}>
                        </div> : null
                }

                <div id="shu" style={{ width: "55%", height: "35%", position: "absolute", marginTop: "75%", marginLeft: "23%" }}>
                </div>
                
                <div id="fu" style={{
                    width: "40px", right: "7px", height: "45px", position: "absolute"
                    , marginTop: (this.state.planetInfo.isBuried ? (this.state.IsAdmin ? "44%" : "34%") : (this.state.IsAdmin ? "34%" : "34%"))
                    , backgroundRepeat: "no-repeat", backgroundPosition: "right"
                }} onClick={() => {
                    this.setState({
                        visibleXH: true,
                        titleTab: 0,
                        typeTab: 487,
                    })
                    this.loadProduct(487)
                }}>
                </div>
                

                
                <div style={{
                    textAlign: "center", color: "#fff", marginTop: "20%"
                    , zIndex: "99", position: "absolute", width: "100%"
                }}>
                    <div>
                        <div style={{ margin: "auto", width: "80px" }} onClick={() => {
                            // if (this.state.userInfo.openId == this.state.planetInfo.openId) 
                            {
                                this.props.navigate('/formView', { replace: true, state: { id: this.state.id } }); // 传递状态
                            }
                        }}>
                            <Image src={
                                this.state.planetInfo.headImg == null ?
                                    "https://api.weibinyi.com/images/niannian/thtx.jpg" :
                                    environment.apiEndpoint + "/NNFiles/Img/" + this.state.planetInfo.headImg
                            } width={80} height={80} fit='cover' style={{ borderRadius: "50%" }} />
                        </div>
                    </div>
                    <div style={{ marginTop: "2%", color: "#000" }}>
                        <span style={{ fontSize: "20px" }} onClick={() => {
                            // if (this.state.userInfo.openId == this.state.planetInfo.openId) 
                            {
                                this.props.navigate('/formView', { replace: true, state: { id: this.state.id } }); // 传递状态
                            }
                        }}>
                            {this.state.planetInfo.name}
                        </span>
                    </div>
                    <div>
                        <span style={{ fontSize: "14px", color: "#000" }} onClick={() => {
                            // if (this.state.userInfo.openId == this.state.planetInfo.openId) 
                            {
                                this.props.navigate('/formView', { replace: true, state: { id: this.state.id } }); // 传递状态
                            }
                        }}>
                            {
                                this.state.planetInfo.deadDate == null ? this.state.errorInfo :
                                    <>
                                        {dayjs(this.state.planetInfo.birthday).format("YYYY.MM.DD")}
                                        -
                                        {dayjs(this.state.planetInfo.deadDate).format("YYYY.MM.DD")}
                                    </>
                            }
                        </span>
                    </div>
                </div>


                <Popup
                    visible={this.state.visibleQF}
                    onMaskClick={() => {
                        this.setState({
                            visibleQF: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{ margin: "5%" }}>
                        <Grid columns={3} gap={8}>
                            <Grid.Item>
                                <Image style={{ width: "80%", margin: "auto", marginTop: "10%" }}
                                    src={"https://api.weibinyi.com/images/niannian/home_qf1.png"} />
                            </Grid.Item>
                            <Grid.Item>
                                <Image style={{ width: "80%", margin: "auto", marginTop: "10%" }}
                                    src={"https://api.weibinyi.com/images/niannian/home_qf1.png"} />
                            </Grid.Item>
                            <Grid.Item>
                                <Image style={{ width: "80%", margin: "auto", marginTop: "10%" }}
                                    src={"https://api.weibinyi.com/images/niannian/home_qf1.png"} />
                            </Grid.Item>
                            <Grid.Item>
                                <Image style={{ width: "80%", margin: "auto", marginTop: "10%" }}
                                    src={"https://api.weibinyi.com/images/niannian/home_qf1.png"} />
                            </Grid.Item>
                            <Grid.Item>
                                <Image style={{ width: "80%", margin: "auto", marginTop: "10%" }}
                                    src={"https://api.weibinyi.com/images/niannian/home_qf1.png"} />
                            </Grid.Item>
                            <Grid.Item>
                                <Image style={{ width: "80%", margin: "auto", marginTop: "10%" }}
                                    src={"https://api.weibinyi.com/images/niannian/home_qf1.png"} />
                            </Grid.Item>
                        </Grid>

                    </div>

                    <div style={{ margin: "5%" }}>
                        <Button block shape='rounded' color='success' onClick={()=>{
                            this.setState({
                                visibleQF: false,
                                visibleQFOver: true,
                            })
                        }}>
                            确定翻开
                        </Button>
                    </div>

                </Popup>
                

                <Popup
                    visible={this.state.visibleQFOver}
                    onMaskClick={() => {
                        this.setState({
                            visibleQFOver: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{ textAlign: "center", marginTop: "10px", fontSize: "16px" }}>
                        您抽到了<span style={{ fontWeight: "700", marginLeft: "5px" }}>平安健康</span>
                    </div>
                    <div style={{ position: "absolute", fontWeight: "900", right: "5px", marginTop: "-10px" }}>
                        集满有特效
                    </div>
                    <div style={{ margin: "5%" }}>
                        <Image style={{ margin: "auto", width: "20%", margin: "auto" }}
                            src={"https://api.weibinyi.com/images/niannian/home_qf2.png"} />

                    </div>
                    <div style={{ margin: "5%" }}>
                        <Grid columns={2} gap={8}>
                            <Grid.Item>
                                <Button block shape='rounded' color='success'>
                                    重新抽取
                        </Button>
                            </Grid.Item>
                            <Grid.Item>
                                <Button block shape='rounded' color='success'>
                                    祈福
                        </Button>
                            </Grid.Item>

                        </Grid>
                    </div>

                </Popup>



                <ImageViewer
                    image={"https://api.weibinyi.com/images/niannian/home_hua.png"}
                    visible={this.state.visibleImg}
                    onClose={() => {
                        this.setState({
                            visibleImg: false,
                        })
                    }}
                />

                <Popup
                    visible={this.state.visibleXH}
                    onMaskClick={() => {
                        this.setState({
                            visibleXH: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '18px',
                        borderTopRightRadius: '18px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{
                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/3/5-9-25.png')"
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", minHeight: "40vh"
                    }}>
                        <Grid columns={4}>
                            <Grid.Item span={2}>
                                <div style={{
                                    backgroundImage: this.state.titleTab === 0
                                        ? "url('https://api.weibinyi.com/images/niannian/3/5-9-23.png')"
                                        : "url('https://api.weibinyi.com/images/niannian/3/21-19.png')"
                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "45px", width: "100%"
                                    , textAlign: "center", color: this.state.titleTab === 0 ? "#fff" : "#000", fontSize: "17px"
                                    , fontWeight: "600", lineHeight: "45px"
                                }} onClick={() => {
                                    this.setState({
                                        typeTab: 487,
                                        titleTab: 0
                                    })
                                    this.loadProduct(487)
                                }}>
                                    装 扮
                                </div>
                            </Grid.Item>
                            <Grid.Item span={2}>
                                <div style={{
                                    backgroundImage: this.state.titleTab === 0
                                        ? "url('https://api.weibinyi.com/images/niannian/3/5-9-24.png')"
                                        : "url('https://api.weibinyi.com/images/niannian/3/21-20.png')"
                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "45px", width: "100%"
                                    , textAlign: "center", color: this.state.titleTab === 0 ? "#000" : "#fff", fontSize: "17px"
                                    , fontWeight: "600", lineHeight: "45px"
                                }} onClick={() => {
                                    this.setState({
                                        typeTab: 499,
                                        titleTab: 1
                                    })
                                    this.loadProduct(499)
                                }}>
                                    献 祭
                                </div>
                            </Grid.Item>
                        </Grid>
                        <div>

                            {
                                this.state.titleTab == 0 ?
                                    <div style={{
                                        padding: "7px", margin: "0px 10px", fontSize: "15px", borderBottom: "solid 1px #b9b9b9"
                                    }}>
                                        {
                                            this.state.tabTypes.map((item, index) => {
                                                if (index == (this.state.tabTypes.length - 1)) {
                                                    return (<>
                                                        <span className={this.state.typeTab == item.id ? "popupTable" : ""}
                                                            onClick={() => {
                                                                this.setState({
                                                                    typeTab: item.id,
                                                                })
                                                                this.loadProduct(item.id)
                                                            }}>
                                                            {item.text}
                                                        </span>
                                                    </>)
                                                } else {
                                                    return (<>
                                                        <span className={this.state.typeTab == item.id ? "popupTable" : ""}
                                                            onClick={() => {
                                                                this.setState({
                                                                    typeTab: item.id,
                                                                })
                                                                this.loadProduct(item.id)
                                                            }}>
                                                            {item.text}
                                                        </span>
                                                        <Divider direction='vertical' />
                                                    </>)
                                                }
                                            })
                                        }
                                    </div> : null
                            }
                            
                            <div style={{
                                padding: this.state.titleTab == 0 ? "10px" : "15px 10px 20px 10px",
                                maxHeight: "390px", overflowY: "scroll"
                            }}>
                                <Grid columns={3} gap={7}>
                                    {
                                        this.state.products.map(item => {
                                            var name = item.coverPhoto.split('/').pop();
                                            var imgurl = environment.apiEndpoint + "/NNFiles/Img/" + name;

                                            return (<Grid.Item span={1}>
                                                <div onClick={() => {
                                                    this.getProductInfo(item.id);
                                                }}>
                                                    <Image src={imgurl}
                                                        width={"100%"} height={"100%"} fit='cover' onClick={() => {
                                                            this.getProductInfo(item.id);
                                                        }} />
                                                    <div style={{ textAlign: "center", fontSize: "15px", marginTop: "3px" }}>
                                                        {item.name}
                                                    </div>
                                                </div>
                                            </Grid.Item>)
                                        })
                                    }
                                </Grid>
                            </div>

                        </div>

                    </div>
                </Popup>


                <Popup
                    visible={this.state.visibleCP}
                    onMaskClick={() => {
                        this.setState({
                            visibleCP: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '18px',
                        borderTopRightRadius: '18px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{
                        backgroundImage: this.state.titleTab == 0 ?
                            "url('https://api.weibinyi.com/images/niannian/3/5-9-25.png')" : ""
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", minHeight: "40vh"
                    }}>
                        <div>

                            {
                                this.state.titleTab == 0 ?
                                    <div style={{ padding: "10px" }}>
                                        <Grid columns={4} gap={7}>
                                            <Grid.Item span={2}>
                                                <Image src={this.state.productInfo.coverPhoto}
                                                    width={110} height={110} fit='cover' style={{ float: "right" }} />
                                            </Grid.Item>
                                            <Grid.Item span={2}>
                                                <span style={{ fontSize: "14px", fontWeight: "600", lineHeight: "110px" }}>
                                                    {this.state.productInfo.name}
                                                </span>
                                            </Grid.Item>

                                            <Grid.Item span={4}>
                                                <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                                            </Grid.Item>
                                            <Grid.Item span={1}>
                                                <div style={{ textAlign: "center", lineHeight: "70px", fontSize: "15px" }}>
                                                    展示时长
                            </div>
                                            </Grid.Item>
                                            <Grid.Item span={3}>
                                                <JumboTabs activeKey={this.state.productActiveKey} onChange={(key) => {
                                                    var item = this.state.productInfo.productPriceDtos.filter(x => x.id == key);
                                                    this.setState({
                                                        productActiveKey: key,
                                                        productInfoPrice: item.length == 0 ? 0 : item[0].price
                                                     });
                                                }}>
                                                    {
                                                        this.state.productInfo.productPriceDtos == null ? null :
                                                        this.state.productInfo.productPriceDtos.map(item => {
                                                            return (<JumboTabs.Tab title={item.typeName}
                                                                description={'￥' + (item.price || 0).toFixed(1)}
                                                                key={item.id}>
                                                            </JumboTabs.Tab>)
                                                        })
                                                    }
                                                </JumboTabs>
                                            </Grid.Item>
                                            <Grid.Item span={4}>
                                                <div style={{
                                                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-16.png')", backgroundRepeat: "no-repeat"
                                                    , backgroundSize: "100% 100%", height: "38px", width: "94%", marginLeft: "3%", marginTop: "5px"
                                                    , marginBottom: "20px"
                                                }}>
                                                    <Grid columns={4} gap={8}>
                                                        <Grid.Item span={3}>
                                                            <span style={{ fontSize: "13px", marginLeft: "25px" }}>合计</span>
                                                            <span style={{
                                                                fontSize: "24px", fontWeight: "600", marginLeft: "8px"
                                                            }}>
                                                                ￥{(this.state.productInfoPrice || 0).toFixed(1)}
                                                            </span>
                                                        </Grid.Item>
                                                        <Grid.Item span={1}>
                                                            <div style={{
                                                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-17.png')"
                                                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                                                , lineHeight: "38px", textAlign: "center", fontSize: "15px", color: "#fff"
                                                            }} onClick={() => {
                                                                this.payProduct();
                                                            }}>
                                                                购 买
                                </div>
                                                        </Grid.Item>
                                                    </Grid>
                                                </div>
                                            </Grid.Item>
                                        </Grid>
                                    </div>
                                    :

                                    <div style={{ padding: "20px 10px 10px 10px" }}>
                                        <Grid columns={4} gap={7}>
                                            <Grid.Item span={4}>
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <Image src={this.state.productInfo.coverPhoto}
                                                        width={110} height={110} fit='cover' style={{ float: "right" }} />
                                                </div>
                                            </Grid.Item>
                                            <Grid.Item span={4}>
                                                <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                                            </Grid.Item>
                                            <Grid.Item span={2}>
                                                <div style={{ float: "right", lineHeight: "35px", marginRight: "10px" }}>
                                                    <span style={{ fontSize: "14px", fontWeight: "600" }}>
                                                        {this.state.productInfo.name}
                                                    </span>
                                                </div>
                                            </Grid.Item>
                                            <Grid.Item span={2}>
                                                <div style={{lineHeight: "35px"}}>
                                                    <span style={{
                                                        fontSize: "13px", fontWeight: "600",
                                                        marginLeft: "10px", color: "#7c7c7c"
                                                    }}>
                                                        {!this.state.productInfoPrice ? "免费"
                                                            : `￥${this.state.productInfoPrice.toFixed(1)}`}
                                                    </span>
                                                </div>
                                            </Grid.Item>
                                            <Grid.Item span={4}>
                                                <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                                            </Grid.Item>
                                            {/* <Grid.Item span={4}>
                                                <div style={{
                                                    display: "flex", justifyContent: "center", marginTop: "20px",
                                                    marginBottom: "10px"
                                                }}>
                                                    <span style={{ marginRight: "5px", fontSize: "13px", lineHeight: "12px" }}>
                                                        成为会员获取更多
                                                    </span>
                                                    <Image src={"https://api.weibinyi.com/images/niannian/3/22-27.png"}
                                                        width={15} height={15} fit='cover' style={{ float: "right" }} />
                                                </div>
                                            </Grid.Item> */}
                                            <Grid.Item span={4}>
                                                <div style={{
                                                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                                    , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                                    , fontWeight: "600", color: "#fff", marginBottom: "25px", marginTop: "10px"
                                                }} onClick={() => {
                                                    this.payProduct();
                                                }}>
                                                    敬 献
                                                </div>
                                            </Grid.Item>
                                            
                                        </Grid>
                                    </div>
                            }

                        </div>

                    </div>
                </Popup>



                {
                    this.state.isShow ?
                        <div
                            style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/41-18.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100% 100%",
                                height: "100vh",
                                position: "fixed",
                                width: "100%",
                                top: "0px",
                                left: "0px",
                                zIndex: "9999",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                paddingTop: "45%",
                            }}
                            onClick={() => {
                                this.setState({ isShow: false });
                            }}
                        >
                            {/* 图片容器 - 添加动画 */}
                            <div style={{
                                position: "relative",
                                width: "80%",
                                maxWidth: "500px",
                                animation: "scaleUp 0.5s ease-out forwards", // 动画名称、时长、缓动函数
                                transformOrigin: "center", // 缩放中心点
                            }}>
                                {/* 底层图片 */}
                                <Image
                                    src="https://api.weibinyi.com/images/niannian/3/23-25.png"
                                    fit="fill"
                                    width="100%"
                                />

                                {/* 上层图片 */}
                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "60%",
                                    zIndex: 1,
                                }}>
                                    <Image
                                        src={this.state.productInfo.coverPhoto}
                                        fit="fill"
                                        width="100%"
                                    />
                                </div>
                            </div>

                            {/* 定义动画（关键帧） */}
                            <style>{`
    @keyframes scaleUp {
      0% {
        transform: scale(0.8);
        opacity: 0;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `}</style>
                        </div>
                        : null
                }

{/* 
                <Image
                    // src={this.state.productInfo.coverPhoto}
                    src="https://api.weibinyi.com/NNFiles/Img/20250512015110.png"
                    fit="fill"
                    width="100%"
                /> */}

                {
                    this.state.visibleShare ?
                        <div style={{ height: "90%", width: "100%", zIndex: "999", position: "fixed", top: "0" }}
                        onClick={()=>{
                            this.setState({
                                visibleShare: false
                            })
                        }}>
                            <Image src={"https://api.weibinyi.com/images/niannian/4/share.png"}
                                fit='fill' width={"100%"} height={"100%"} />
                        </div> : null
                }

                <TextCarousel
                    messages={this.state.messages}
                    jumpGiftList={()=>{
                        this.props.navigate('/giftList', { replace: true, state: { id: this.state.id } });
                    }}
                    visibleCount={4}
                    interval={2000} // 2秒切换一次
                />

                {/* <div className="landscape" style={{ }}></div>
                <div className="filter" style={{  }}></div>
                <canvas id="canvas"></canvas> */}

                <BottomMenu position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);